import { useParams, useScreenMessage } from '@gogame/screens';

import { exportNodesMarketingPlan } from 'scenes/MarketingPlanning/MarketingPlanningWizard/sources/plan';

export const useExportNodesMarketingPlan = () => {
  const { showSuccessMessage, showErrorMessage } = useScreenMessage();
  const { year, month } = useParams();
  return ({ parentId, version }) => {
    exportNodesMarketingPlan({
      year,
      month,
      parentId,
      version,
    })
      .catch((e) => {
        showErrorMessage(e.message);
        return Promise.reject(e);
      })
      .then(() => {
        showSuccessMessage('Nodes marketing planning was downloaded.');
      });
  };
};
